import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import slugify from "slugify";

// Components
import UploadXML from "../UI/UploadXML";
import Modal from "../UI/Modal";
import ForceModal from "../UI/Modal/ForceModal";

//
import FormActions from "../../store/actions/FormActions";
import FormMiddlewares from "../../store/middlewares/FormMiddlewares";
import NotificationActions from "../../store/actions/NotificationActions";
import UserActions from "../../store/actions/UserActions";
import Paths from "../../utils/paths";
import { generateXMLString } from "../../utils/functions/xml";

const NavbarNavigation = ({
  setValidateClicked,
  showHighlight,
  setShowHighlight,
}) => {
  const dispatch = useDispatch();
  const [importModalOpen, setImportModalOpen] = useState(false);

  const { form, savedInBrowser, isValid, fileName } = useSelector(
    (state) => state.form
  );
  const { isLoggedin, user } = useSelector((state) => state.user);
  const { activeCheckboxes, activeChildrens, ...rest } = form;
  const { t } = useTranslation();

  const downloadXMLUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(
    generateXMLString(rest, activeCheckboxes, activeChildrens)
  )}`;
  const downloadFileName = `${slugify(form?.title || "sample", {
    lower: true,
    strict: true,
  })}.xml`;

  const exportXMLHandler = (e) => {
    if (isValid) {
    } else {
      dispatch(FormActions.showErrorsStart());
      e.preventDefault();
    }
  };

  const resetFormHandler = () => {
    dispatch(FormActions.resetFormStart());
  };

  const saveInBrowser = () => {
    dispatch(FormActions.saveinBrowser());
    dispatch(
      NotificationActions.addNotification(
        "Data saved in browser successfully",
        "success"
      )
    );
  };

  const loadFromBrowser = () => {
    dispatch(FormActions.loadFromBrowserStart());
  };

  const publishXMLHandler = () => {
    if (!isLoggedin) {
      return;
    }

    dispatch(FormMiddlewares.publishXML());
  };

  const toggleImportModal = () => {
    setImportModalOpen((prev) => !prev);
  };
  const closeImportModal = () => {
    setImportModalOpen(false);
  };

  const openMenuHandler = () => {
    closeImportModal();
    setShowHighlight(false);
  };

  return (
    <>
      <ForceModal
        downloadXMLUrl={downloadXMLUrl}
        downloadFileName={fileName || downloadFileName}
      />
      <Modal />
      {importModalOpen && (
        <div className="upload-xml-popover">
          <div className="paper">
            <UploadXML onAction={closeImportModal} />
          </div>
          <div className="backdrop" onClick={closeImportModal}></div>
        </div>
      )}
      <div className={`dropdown ${showHighlight ? "highlight" : ""}`}>
        <button
          className={`navmenu-toggler dropdown-toggle hide-toggle-icon`}
          type="button"
          id="navbarToggleNavMenu"
          data-bs-toggle="dropdown"
          data-bs-target="#navbarToggleNavMenu"
          aria-controls="navbarToggleNavMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={openMenuHandler}
        >
          <i className="bi bi-list"></i>
        </button>
        <ul
          className="dropdown-menu dropdown-menu-end user-menu"
          aria-labelledby="navbarToggleNavMenu"
        >
          <li>
            <button
              className="dropdown-item"
              onClick={resetFormHandler}
              type="button"
            >
              <i className="bi bi-plus-circle" /> {t("navbar.createLink")}
            </button>
          </li>
          <li>
            <button
              className="dropdown-item"
              onClick={toggleImportModal}
              type="button"
            >
              <i className="bi bi-file-earmark-arrow-up" />{" "}
              {t("navbar.uploadLink")}
            </button>
          </li>
          {/* Export XML */}
          <li>
            {isValid ? (
              <a
                className="dropdown-item"
                href={downloadXMLUrl}
                download={fileName || downloadFileName}
                id="export-xml-link"
              >
                <i className="bi bi-arrow-right-square" />{" "}
                {t("statusBar.exportButton")}
              </a>
            ) : (
              <button
                className="dropdown-item"
                id="export-xml-link"
                data-bs-target="#forceExport"
                type="submit"
                data-bs-toggle="modal"
                data-bs-target="#forceExport"
                onClick={() => {
                  setValidateClicked(true);
                }}
              >
                <i className="bi bi-arrow-right-square" />{" "}
                {t("statusBar.exportButton")}
              </button>
            )}
          </li>
          <li>
            <button className="dropdown-item" onClick={saveInBrowser}>
              <i className="bi bi-save" /> {t("navbar.saveLink")}
            </button>
          </li>
          {savedInBrowser && (
            <li>
              <button className="dropdown-item" onClick={loadFromBrowser}>
                <i className="bi bi-arrow-counterclockwise" />
                {t("navbar.loadLink")}
              </button>
            </li>
          )}
          <li>
            <button
              className="dropdown-item"
              onClick={publishXMLHandler}
              disabled={!isValid}
              data-bs-toggle={isLoggedin ? "" : "modal"}
              data-bs-target={isLoggedin ? "" : "#loginRequired"}
            >
              <i className="bi bi-arrow-counterclockwise" />{" "}
              {t("navbar.publishLink")}
            </button>
            {isLoggedin && (
              <a
                className="dropdown-item"
                target="_blank"
                href={`${Paths.BASE_URL}/${user.publishId}/xml`}
              >
                {t("navbar.openXMLLink")}
              </a>
            )}
          </li>
          {!isLoggedin && (
            <li>
              <Link className="dropdown-item" to="/signup">
                <i className="bi bi-person-plus" /> {t("navbar.signupLink")}
              </Link>
            </li>
          )}
          {!isLoggedin && (
            <li>
              <Link className="dropdown-item" to="/login">
                <i className="bi bi-arrow-right-square" />{" "}
                {t("navbar.loginLink")}
              </Link>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default NavbarNavigation;
